<template>
    <div>
        <label v-if="!tableView" class="form-label d-flex align-items-center flex-wrap">
            {{ fieldData['title_' + getLang()] }}
            <span class="input-group__required" v-if="fieldData.required">*</span>

            <info-label
                v-if="fieldData.settings && fieldData.settings.tooltip"
                :text="fieldData.settings.tooltip"
            />
        </label>

        <textarea
            :name="fieldData.code"
            :id="fieldData.code"
            v-model="fieldValue"
            :class="tableView ? 'table-input w-100' : (validationErrors ? 'form-control-1 border-danger mb-1' : 'form-control-1')"
            :disabled="!isEditible"
            rows="4"
        ></textarea>

        <div v-if="!tableView && validationErrors">
            <span v-for="error in validationErrors" class="error-text d-block">{{ error }}</span>
        </div>
    </div>
</template>

<script>
import InfoLabel from '../ui/InfoLabel.vue';

export default {
    name: 'text-area',
    components: {InfoLabel},
    props: {
        field: Object,
        isEditible: Boolean,
        oldData: String,
        modelValue: String,
        tableView: Boolean,
        validationErrors: Object,
    },
    data() {
        return {
            fieldData: {},
        };
    },
    computed: {
        fieldValue: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit('update:modelValue', value);
            },
        },
    },
    mounted() {
        this.fieldData = this.field;

        if (!this.fieldData.settings || Array.isArray(this.fieldData.settings)) {
            this.fieldData.settings = {};
        }

        this.fieldValue = this.oldData ?? '';
    },
    methods: {
        getLang() {
            return document.querySelector('html').getAttribute('lang') || 'ru';
        },
    },
};
</script>
